// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/live-axios';
import { dispatch } from '../index';

// types
import { DefaultRootStateProps } from 'types';
import { TSetVariable } from 'types/variables';

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['variable'] = {
	error: null,
	variables: [],
};

const slice = createSlice({
	name: 'config',
	initialState,
	reducers: {
		hasError(state, action) {
			state.error = action.payload;
		},

		getConfigSuccess(state, action) {
			state.variables = action.payload;
		},
	},
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export const variableApi = {
	getAll: () => async () => {
		try {
			const response = await axios.get('/config');
			dispatch(slice.actions.getConfigSuccess(response.data));
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	},
	get update() {
		return async (
			id: number,
			data: TSetVariable,
			options?: { sync: boolean }
		) => {
			try {
				await axios.put(`/config/${id}`, data);
				if (options?.sync === true) this.getAll()();
			} catch (error) {
				if (options?.sync === true) dispatch(slice.actions.hasError(error));
			}
		};
	},
};
